export async function fetchHTML(url) {
  const response = await fetch(`${url}`);
  return new DOMParser().parseFromString(await response.text(), 'text/html');
}
